import React from 'react'
import PropTypes from 'prop-types'

const RadioButton = props => {
  return (
    <label>
      <input
        name={props.name}
        type="radio"
        value={props.value}
        checked={props.checked}
        onChange={props.handler}
      />
      &nbsp;{props.label}
    </label>
  )
}
RadioButton.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  handler: PropTypes.func,
}
export default RadioButton
